
define('eteration/widgets/ui-datelabel',[
		'knockout',
		'eteration/widgets/widget-util',
		'moment'
	],
	function(ko, widgetUtil, moment) {

		widgetUtil.setupStringBasedTemplate(ko);

		ko.templates["date-label"] = "\
				<!-- ko if:isMultiValid-->\
					<span id=\"calendarValue\" class=\"filter-option date-label-content\">\
						<span id=\"selectFlightDate01\" class=\"date-view\">\
							<span class=\"date-type text-center\" data-bind=\"i18n-text: { key: 'TextField-OB-32'}\"></span>\
							<span class=\"date-view-date d-none d-sm-block text-center\" data-bind=\"text:startDateDay\"></span>\
							<span class=\"date-view-date d-block d-sm-none text-center\" data-bind=\"text:startDateDayMin\"></span>\
							<span class=\"date-view-day text-center\" data-bind=\"text:startDate\"></span>\
							<span class=\"date-view-month text-center\" data-bind=\"text:startDateMonth\"></span>\
						</span>\
						<span id=\"selectFlightDate02\" class=\"date-view\">\
							<span class=\"date-type\" data-bind=\"i18n-text: { key: 'TextField-OB-33'}\"></span>\
							<span class=\"date-view-date d-none d-sm-block\" data-bind=\"text:endDateDay\"></span>\
							<span class=\"date-view-date d-block d-sm-none\" data-bind=\"text:endDateDayMin\"></span>\
							<!-- ko if:hasEndDate-->\
								<span class=\"date-view-day\" data-bind=\"text:endDate\"></span>\
							<!-- /ko  -->\
							<!-- ko if:!hasEndDate()-->\
								<span class=\"date-view-day\" >\
									<i class=\"glyphicon icon-calendar\"></i>\
									<i class=\"fa fa-caret-down\"></i>\
								</span>\
							<!-- /ko  -->\
							<span class=\"date-view-month\" data-bind=\"text:endDateMonth\"></span>\
						</span>\
					</span>\
				<!-- /ko  -->\
				<!-- ko if:isSingleValid-->\
					<span id=\"calendarValue\" class=\"filter-option date-label-content isOneWay\">\
						<span id=\"selectFlightDate01\" class=\"date-view\">\
							<span class=\"date-type text-center\" data-bind=\"i18n-text: { key: routeLabel }\"></span>\
							<span class=\"date-view-date text-center\" data-bind=\"text:startDateDay\"></span>\
							<span class=\"date-view-day text-center\" data-bind=\"text:startDate\"></span>\
							<span class=\"date-view-month text-center\" data-bind=\"text:startDateMonth\"></span>\
						</span>\
					<!-- ko if:showPlaneIcon-->\
						<span class=\"date-view-oneway\">\
							<span class=\"date-view-date\"  data-bind=\"i18n-text: { key: 'Label-OB-59'}\"></span>\
							<i class=\"icon-set icon-set-plane icon-gray rotateRTL\"></i>\
						</span>\
					<!-- /ko  -->\
					</span>\
				<!-- /ko  -->\
				<!-- ko ifnot:isValid-->\
					<span id=\"calendarPlaceholder\" class=\"filter-option\">\
						<span class=\"date-view date-hidden\" data-bind=\"i18n-text: { key: 'Label-OB-58'}\"  ></span>\
						<span class=\"date-view\">\
							<i class=\"glyphicon icon-calendar\"></i>\
							<i class=\"fa fa-caret-down\"></i>\
						</span>\
					</span>\
				<!-- /ko  -->";

		ko.bindingHandlers['date-label'] = {

			makeTemplateValueAccessor : function(valueAccessor, allBindings, element) {

				var single = valueAccessor().single ? valueAccessor().single() : true;
				var firstDate = ko.unwrap(valueAccessor().firstDate);
				var secondDate = ko.unwrap(valueAccessor().secondDate);
				var dates = single ? [firstDate] : [ firstDate, secondDate ] ;
				var noPlane =  valueAccessor().noplane ? valueAccessor().noplane : false;
				var tripType = valueAccessor().tripType || null;
				var index = valueAccessor().index;
				var isChangeFlight = valueAccessor().isChangeFlight || false;
				var routeLabel = 'TextField-OB-32';

				if(firstDate == undefined && (secondDate == undefined || secondDate == '')){
					dates = [];
				}

				return function() {
					return {
						name : 'date-label',
						data : {
							startDate : ko.computed(function() {
								if (dates.length > 0)
									return moment.utc(dates[0]).format('DD');
							}),

							startDateDay : ko.computed(function() {
								if (dates.length > 0)
									return moment.utc(dates[0]).format('dddd');
							}),

							startDateDayMin : ko.computed(function() {
								if (dates.length > 0)
									return moment.utc(dates[0]).format('ddd');
							}),

							startDateMonth : ko.computed(function() {
								if (dates.length > 0)
									return moment.utc(dates[0]).format('MMM');
							}),

							endDate : ko.computed(function() {
								if (dates.length == 2 && dates[1] && dates[1] != "")
									return moment.utc(dates[1]).format('DD');
							}),

							hasEndDate : ko.computed(function() {
								if (dates.length == 2 && dates[1] && dates[1] != "")
									return true;
								return false;
							}),

							endDateDay : ko.computed(function() {
								if (dates.length == 2 && dates[1] && dates[1] != "")
									return moment.utc(dates[1]).format('dddd');
							}),

							endDateDayMin : ko.computed(function() {
								if (dates.length == 2 && dates[1] && dates[1] != "")
									return moment.utc(dates[1]).format('ddd');
							}),

							endDateMonth : ko.computed(function() {
								if (dates.length == 2 && dates[1] && dates[1] != "")
									return moment.utc(dates[1]).format('MMM');
							}),
							isValid : ko.computed(function() {
								if ((single && dates.length == 1 && dates[0]!="") || (!single && dates.length == 2 &&  dates[0]!=""))
									return true;
								return false;
							}),
							isSingleValid : ko.computed(function() {

								if ((single && dates.length == 1  && dates[0]!=""))
									return true;
								return false;
							}),
							showPlaneIcon : ko.computed(function() {
								if (!noPlane)
									return true;
								return false;
							}),
							isMultiValid : ko.computed(function() {

								if (!single && dates.length == 2 && dates[0]!="")
									return true;
								return false;
							}),
							tripType: ko.computed(function(){
								return tripType;
							}),
							index: ko.computed(function(){
								return index;
							}),
							routeLabel: ko.computed(function(){
								if(tripType == 'ROUND_TRIP' && isChangeFlight) {
									if(index == 1) {
										routeLabel = 'TextField-OB-33';
									}
								}
								return routeLabel;
							}),
						}
					};
				};
			},
			init : function(element, valueAccessor, allBindings) {
				return ko.bindingHandlers.template.init(element, ko.bindingHandlers['date-label'].makeTemplateValueAccessor(valueAccessor, allBindings, element), allBindings);
			},
			update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
				return ko.bindingHandlers.template.update(element, ko.bindingHandlers['date-label'].makeTemplateValueAccessor(valueAccessor, allBindings, element), allBindings, viewModel, bindingContext);
			}
		};
		ko.virtualElements.allowedBindings['date-label'] = true;

	});

